import { Link, LinkProps } from '@chakra-ui/react'
import NextLink from 'next/link'
import { FC } from 'react'

import { resolveInternalHref } from '../publishable'

export interface OrganicLinkProps extends Omit<LinkProps, 'href'> {
  /** Site-relative path of a registry entry, e.g. `/mounjaro`. */
  path: string
}

/**
 * Contextual internal link that can never be broken (PRD §17, §30): renders an anchor only when the
 * target is in the publishable list, otherwise just its children as plain text. Pages written with it
 * gain their links automatically when the target entry is published.
 */
export const OrganicLink: FC<OrganicLinkProps> = ({ path, children, ...rest }) => {
  const href = resolveInternalHref(path)
  if (!href) return <>{children}</>

  return (
    <Link as={NextLink} href={href} textDecoration="underline" {...rest}>
      {children}
    </Link>
  )
}

export default OrganicLink
